import type { Mission } from '../missions.ts'

export const tsa: Mission = {
  id: "tsa",
  name: "Transportation Security Administration",
  short: "TSA",
  call: "Travel",
  kind: "subagency",
  parent: "dhs",
  url: "https://www.tsa.gov/",
  established: 2001,
  palette: {
    primary: "#0079ad",
    secondary: "#005287",
    accent: "#c31230",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Transportation_Security_Administration_seal.svg",
  },
  motif: "eagle",
  mission: {
    text: "Protect the nation's transportation systems to ensure freedom of movement for people and commerce.",
    url: "https://www.tsa.gov/about/tsa-mission",
  },
  fact: {
    text: "TSA was established by the Aviation and Transportation Security Act, signed into law on November 19, 2001.",
    url: "https://www.tsa.gov/timeline",
  },
  seal: {
    file: "public/seals/tsa.svg",
    source: "https://commons.wikimedia.org/wiki/File:Transportation_Security_Administration_seal.svg",
  },
  identifier: {
    about: "https://www.tsa.gov/about",
    accessibility: "https://www.tsa.gov/accessibility",
    foia: "https://www.tsa.gov/foia",
    noFear: "https://www.tsa.gov/no-fear-act",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.tsa.gov/about/strategy",
    privacy: "https://www.tsa.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/tsa-checkpoint.jpg",
        small: "/media/tsa-checkpoint-sm.jpg",
        alt: "A TSA officer in a blue uniform works at a checkpoint roller conveyor stacked with gray bins in an airport terminal.",
        title: "TSA security checkpoint, Harry Reid International Airport, Las Vegas, April 24, 2024",
        creator: "U.S. Department of Homeland Security",
        source: "https://commons.wikimedia.org/wiki/File:DHS_Senior_Official_Performing_the_Duties_of_the_Deputy_Secretary_Kristie_Canegallo_Travels_to_Las_Vegas_(53679991407).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/tsa-canine.jpg",
        small: "/media/tsa-canine-sm.jpg",
        alt: "A yellow detection dog in a working vest lies on a blue carpet chewing a tennis ball beside its handler's boots.",
        title: "Detection canine at a House Homeland Security subcommittee hearing on DHS canine programs, May 18, 2017",
        creator: "U.S. Customs and Border Protection",
        source: "https://commons.wikimedia.org/wiki/File:Homeland_Security_dog,_2017.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
